/* eslint-disable import/prefer-default-export */
import { getCustomer } from "../../util/user";

const MAPPINGS = {
  'G-RATE': 'M-LOSS',
  'G-Rate': 'M-Loss',
  'g-rate': 'm-loss',
  'grate': 'mloss',
}

export const targaHackLabelSwapIliGRate = (label) => { 
  const customer = getCustomer();
  // if (customer !== 'Targa' && customer !== 'Aegion' && customer !== 'BNS Midstream') { 
  if (customer !== 'Targa') { 
    return label;
  }

  return MAPPINGS[label] || label;
}